import React from 'react';
import { useTranslation } from 'react-i18next';

import HeartIco from '../../assets/images/Heart.svg';
import {
  FooterWrapper,
  Copyright,
  MakedWraper,
  Maked,
  Heart,
  Mail,
} from './Footer.styled';

export const Footer = () => {
  const { t } = useTranslation();

  const width =
    typeof window !== 'undefined' ? window.innerWidth : 0;
  const isMobile = width <= 768;

  return (
      <FooterWrapper>
        <Copyright>Copyright VIDIFY ©️ 2022</Copyright>
        {!isMobile ? (
          <MakedWraper>
            <Maked>{t('maked')}</Maked>
            <Heart src={HeartIco} alt='heart' />
          </MakedWraper>
        ) : null}
        <Mail
          href='mailto:vidify.online@gmail.com'
          target='_blank'
          rel='noreferrer'>
          Email: vidify.online@gmail.com
        </Mail>
        {isMobile ? (
          <MakedWraper>
            <Maked>{t('maked')}</Maked>
            <Heart src={HeartIco} alt='heart' />
          </MakedWraper>
        ) : null}
      </FooterWrapper>
  );
};
